module.exports = __webpack_public_path__ + "static/img/banner.39583ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/health/banner.jpg
// module id = BNZJ
// module chunks = 1